import { s as subscribe } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, v as validate_component, i as each } from "../../../../../chunks/ssr.js";
import "../../../../../chunks/api.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { L as Label } from "../../../../../chunks/Label.js";
import { I as Input } from "../../../../../chunks/Input.js";
import { S as Select } from "../../../../../chunks/Select.js";
import { M as Modal } from "../../../../../chunks/Modal2.js";
import { H as Heading } from "../../../../../chunks/Heading.js";
import { a as allUnits } from "../../../../../chunks/unit.js";
import { P as PlusOutline } from "../../../../../chunks/PlusOutline.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $allUnits, $$unsubscribe_allUnits;
  $$unsubscribe_allUnits = subscribe(allUnits, (value) => $allUnits = value);
  let newCostCenter = { name: "", key: "", unitId: 1 };
  let sortedCostCenters = [];
  let open = false;
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="flex gap-5"><section class="flex-1">${validate_component(Heading, "Heading").$$render(
      $$result,
      {
        class: "text-neutral-500 mb-3 flex justify-between",
        tag: "h3"
      },
      {},
      {
        default: () => {
          return `<span data-svelte-h="svelte-14qxogj">Kostenstellen</span> ${validate_component(Button, "Button").$$render($$result, {}, {}, {
            default: () => {
              return `${validate_component(PlusOutline, "PlusOutline").$$render($$result, {}, {}, {})} Neue Kostenstelle`;
            }
          })}`;
        }
      }
    )} ${each(sortedCostCenters, (costCenter) => {
      return `<form class="grid grid-cols-6 gap-3 mb-3">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 col-span-2" }, {}, {
        default: () => {
          return `<span data-svelte-h="svelte-15ueaex">Name</span> ${validate_component(Input, "Input").$$render(
            $$result,
            { type: "text", value: costCenter.name },
            {
              value: ($$value) => {
                costCenter.name = $$value;
                $$settled = false;
              }
            },
            {}
          )} `;
        }
      })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
        default: () => {
          return `<span data-svelte-h="svelte-19iqio2">Kostenstellenschlüssel</span> ${validate_component(Input, "Input").$$render(
            $$result,
            { type: "text", value: costCenter.key },
            {
              value: ($$value) => {
                costCenter.key = $$value;
                $$settled = false;
              }
            },
            {}
          )} `;
        }
      })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2 col-span-2" }, {}, {
        default: () => {
          return `<span data-svelte-h="svelte-kp7nlg">Unit</span> ${validate_component(Select, "Select").$$render(
            $$result,
            {
              items: $allUnits.map((x) => ({ value: x.id, name: x.name })),
              value: costCenter.unitId
            },
            {
              value: ($$value) => {
                costCenter.unitId = $$value;
                $$settled = false;
              }
            },
            {}
          )} `;
        }
      })} <div class="grid place-items-end">${validate_component(Button, "Button").$$render($$result, { type: "submit" }, {}, {
        default: () => {
          return `Update`;
        }
      })}</div> </form>`;
    })}</section></div> ${validate_component(Modal, "Modal").$$render(
      $$result,
      { class: "w-full", open },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${validate_component(Heading, "Heading").$$render($$result, { class: "text-neutral-500", tag: "h3" }, {}, {
            default: () => {
              return `Neue Kostenstelle`;
            }
          })} <form class="grid gap-5">${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-15ueaex">Name</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { type: "text", value: newCostCenter.name },
                {
                  value: ($$value) => {
                    newCostCenter.name = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-19iqio2">Kostenstellenschlüssel</span> ${validate_component(Input, "Input").$$render(
                $$result,
                { type: "text", value: newCostCenter.key },
                {
                  value: ($$value) => {
                    newCostCenter.key = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} ${validate_component(Label, "Label").$$render($$result, { class: "space-y-2" }, {}, {
            default: () => {
              return `<span data-svelte-h="svelte-kp7nlg">Unit</span> ${validate_component(Select, "Select").$$render(
                $$result,
                {
                  items: $allUnits.map((x) => ({ value: x.id, name: x.name })),
                  value: newCostCenter.unitId
                },
                {
                  value: ($$value) => {
                    newCostCenter.unitId = $$value;
                    $$settled = false;
                  }
                },
                {}
              )}`;
            }
          })} <div>${validate_component(Button, "Button").$$render($$result, { type: "submit" }, {}, {
            default: () => {
              return `Anlegen`;
            }
          })}</div></form>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_allUnits();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
